<template>
  <ModalVue
    :modalActive="showModal"
    :hasHeaderBorder="true"
    :hasFooterBorder="true"
    :noBodyPadding="true"
    @close="emit('cancel')"
  >
    <template #header>
      <span class="font-bold text-lg text-textPrimary">Desligar "ocupado sem identificação"?</span>
    </template>

    <!--
      O padding fica neste wrapper, e não no <main> do Modal.vue: este diálogo abre dentro do
      "Editar Escala" (.figma-custom-modal), cujo `:deep(main) { padding: 0 !important }` também
      atinge o <main> de qualquer modal aninhado.
    -->
    <div
      class="flex flex-col gap-3 px-4 py-4 md:px-6 text-left text-sm text-textPrimary"
      data-testid="disable-unidentified-body"
    >
      <p>
        Os plantões já marcados continuam ocupados sem identificação. Novas marcações ficam
        bloqueadas.
      </p>
      <div class="flex gap-3">
        <span
          class="rounded-md bg-gray-100 px-3 py-2 font-bold"
          data-testid="disable-unidentified-future"
          >{{ formatCount(futureCount) }} futuros</span
        >
        <span class="rounded-md bg-gray-100 px-3 py-2" data-testid="disable-unidentified-past"
          >{{ formatCount(pastCount) }} passados (não mudam)</span
        >
      </div>
      <label v-if="futureCount > 0" class="flex items-start gap-2 cursor-pointer">
        <input
          v-model="releaseFuture"
          type="checkbox"
          class="mt-1"
          data-testid="disable-unidentified-release-future"
        />
        <span>
          <b>Liberar os {{ formatCount(futureCount) }} futuros como vaga aberta</b>
          <span class="block text-xs text-[#68688D]">
            Opcional. O responsável é removido e eles entram nas métricas de vaga. Os passados nunca
            são alterados.
          </span>
        </span>
      </label>
    </div>

    <template #footer>
      <div class="flex justify-end gap-3 w-full p-4">
        <OutlineButton
          height="48px"
          color="grey"
          data-testid="disable-unidentified-cancel"
          @click="emit('cancel')"
          >Cancelar</OutlineButton
        >
        <FilledButton
          height="48px"
          color="negative"
          data-testid="disable-unidentified-confirm"
          @click="emit('confirm', releaseFuture)"
          >Desligar</FilledButton
        >
      </div>
    </template>
  </ModalVue>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'

const props = defineProps<{ showModal: boolean; futureCount: number; pastCount: number }>()
const emit = defineEmits<{ confirm: [releaseFuture: boolean]; cancel: [] }>()

// Q30-A: o atalho nasce DESMARCADO a cada abertura.
const releaseFuture = ref(false)
watch(
  () => props.showModal,
  (open) => {
    if (open) releaseFuture.value = false
  }
)

const formatCount = (value: number) => value.toLocaleString('pt-BR')
</script>
